import { createFileRoute } from "@tanstack/react-router";

import AdvancedInsightsPage from "@/pages/AdvancedInsightsPage";

export const Route = createFileRoute("/_app/(insights)/advanced-insights-v2")({
  component: () => <AdvancedInsightsPage />,
});
